
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_1u1vg_97",
  "button": "awsui_button_vjswe_1u1vg_101",
  "variant-normal": "awsui_variant-normal_vjswe_1u1vg_125",
  "is-activated": "awsui_is-activated_vjswe_1u1vg_138",
  "variant-icon": "awsui_variant-icon_vjswe_1u1vg_165",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_1u1vg_165",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_1u1vg_165",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_1u1vg_183",
  "disabled": "awsui_disabled_vjswe_1u1vg_201",
  "variant-primary": "awsui_variant-primary_vjswe_1u1vg_209",
  "variant-link": "awsui_variant-link_vjswe_1u1vg_293",
  "variant-inline-link": "awsui_variant-inline-link_vjswe_1u1vg_545",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_1u1vg_799",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_1u1vg_886",
  "button-no-text": "awsui_button-no-text_vjswe_1u1vg_970",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_1u1vg_974",
  "full-width": "awsui_full-width_vjswe_1u1vg_977",
  "icon-left": "awsui_icon-left_vjswe_1u1vg_994",
  "icon-right": "awsui_icon-right_vjswe_1u1vg_999",
  "icon": "awsui_icon_vjswe_1u1vg_994"
};
  